/* GT design page - see the artwork large. Added 26 Sep 2026, zoom 28 Sep.
   Loaded only by sections/gt-ag-design.liquid. Plain JS, native <dialog>.

   1. Click the artwork on the page -> lightbox opens, picture FITTED.
   2. "Zoom in" or a click on the picture -> picture at its REAL pixel size,
      centred on the spot that was clicked. Drag with the mouse, or scroll /
      swipe, to move around it. Click again or "Fit to screen" to go back.
   Why: fitted, a 2000px mockup is squeezed into ~800px of screen, so fine
   brushwork is lost. At real size nothing is thrown away.

   The full-size file is only fetched on the first open (data-src). No JS or
   no <dialog> support = the link opens the image file itself. */
(function () {
  function init() {
    document.querySelectorAll('[data-gt-ag-zoom]').forEach(function (link) {
      var box = link.parentNode.querySelector('[data-gt-ag-lightbox]');
      if (!box || typeof box.showModal !== 'function') return;
      var stage = box.querySelector('[data-gt-ag-stage]');
      var img = stage.querySelector('img');
      var toggle = box.querySelector('[data-gt-ag-toggle]');
      var dragged = false;

      function setZoom(on, fx, fy) {
        // fx, fy = where the click landed, as a fraction of the fitted picture
        box.classList.toggle('is-zoomed', on);
        toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
        toggle.textContent = on ? toggle.getAttribute('data-out') : toggle.getAttribute('data-in');
        if (on) {
          if (fx == null) { fx = 0.5; fy = 0.5; }
          requestAnimationFrame(function () {
            stage.scrollLeft = img.offsetWidth * fx - stage.clientWidth / 2;
            stage.scrollTop = img.offsetHeight * fy - stage.clientHeight / 2;
          });
        } else {
          stage.scrollLeft = 0; stage.scrollTop = 0;
        }
      }

      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (!img.src) img.src = img.getAttribute('data-src');
        setZoom(false);
        box.showModal();
      });
      toggle.addEventListener('click', function () {
        setZoom(!box.classList.contains('is-zoomed'));
      });
      box.querySelector('[data-gt-ag-close]').addEventListener('click', function () { box.close(); });
      box.addEventListener('close', function () { setZoom(false); });

      img.addEventListener('click', function (e) {
        if (dragged) { dragged = false; return; }
        if (box.classList.contains('is-zoomed')) { setZoom(false); return; }
        var r = img.getBoundingClientRect();
        setZoom(true, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
      });
      // a click on the dark area outside the picture closes it (fitted only)
      stage.addEventListener('click', function (e) {
        if (e.target === stage && !box.classList.contains('is-zoomed')) box.close();
      });

      // drag to pan when zoomed (mouse / pen; fingers already scroll natively)
      var sx, sy, sl, st, down = false;
      stage.addEventListener('pointerdown', function (e) {
        if (!box.classList.contains('is-zoomed') || e.pointerType === 'touch') return;
        down = true; dragged = false;
        sx = e.clientX; sy = e.clientY; sl = stage.scrollLeft; st = stage.scrollTop;
        stage.classList.add('is-dragging');
        e.preventDefault();
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) + Math.abs(dy) > 4) dragged = true;
        stage.scrollLeft = sl - dx; stage.scrollTop = st - dy;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false; stage.classList.remove('is-dragging');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
